import React from 'react';
import { ButtonPrimaryV2, ImageInput, icons } from "oolib";
import { StyledCaretRight, StyledCaretLeft, StyledModalWrapper, StyledModal, StyledActionWrapper, StyledImageWrapper, StyleContentWrapper, StyledLink, StyledImage } from "../styled";
import { colors } from "oolib";
import TagsSection from './TagsSection';


const { CaretRight, CaretLeft } = icons;
const ImageModal = ({ 
  showModal,
  onClose,
  activeIndex,
  onPrevious,
  onNext,
  mediaCollection,
  allTpls,
  fieldConfig, // Add fieldConfig prop
  id, 
}) => {
  if (!showModal) return null;
  
  const activeItem = mediaCollection[activeIndex];

  // Check if any metadata exists based on the fieldConfig
  const hasMetadata = fieldConfig && activeItem.metaData && (
    activeItem.metaData.contentType || 
    Object.keys(fieldConfig.metadataFields || {})
      .some(key => activeItem.metaData[key])
  );

  return (
    <StyledModalWrapper>
      <StyledCaretLeft onClick={onPrevious}>
        <CaretLeft weight="duotone" size={75} color={colors.white} />
      </StyledCaretLeft>
      <StyledCaretRight onClick={onNext}>
        <CaretRight weight="duotone" size={75} color={colors.white} />
      </StyledCaretRight>

      <StyledModal>
        <StyledActionWrapper>
          <ButtonPrimaryV2
            icon="DownloadSimple"
            onClick={() => window.open(activeItem.mediaLink, "_blank")}
          />
          <ButtonPrimaryV2 icon="X" onClick={onClose} />
        </StyledActionWrapper>

        <StyleContentWrapper tagExists={hasMetadata}>
          {hasMetadata && (
            <TagsSection 
              activeItem={activeItem} 
              allTpls={allTpls} 
              fieldConfig={fieldConfig}
            />
          )}
          <StyledLink to={`/published-page/${activeItem.metaData.contentType}?id=${activeItem.id}`}>
            <StyledImageWrapper>
              <StyledImage>
                <ImageInput
                  id={id}
                  stretchToFullHeight
                  readOnly
                  value={[activeItem]}
                />
              </StyledImage>
            </StyledImageWrapper>
          </StyledLink>
        </StyleContentWrapper>
      </StyledModal>
      
    </StyledModalWrapper>
  );
};

export default ImageModal;